import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const steps = ['Open', 'Choose', 'Teach'];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-170" data-mp="1jp64btsvgu3a">
      <div className="mx-auto max-w-5xl" data-id="element-171" data-mp="1ogo5oiyt4wos">
        <SectionHeading id="solution-heading" eyebrow="Meet Barber Instructor Ready™" title={<>
              Six Organized Volumes. <Accent data-id="element-173" data-mp="1ydj5d56th34n">One Complete Teaching System.</Accent>
            </>} body="Designed for barber educators who want a more organized way to prepare, deliver and assess their classes — from professional haircutting techniques to ready-to-teach lessons and student progress tools." data-id="element-172" data-mp="1ohpj2u3apv9o" />

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] font-semibold leading-relaxed text-brand-charcoal sm:text-[16px]" data-id="element-174" data-mp="90z2q2it3eet">
          Open the system. Choose your topic. Prepare your class. Start teaching.
        </p>

        <ol className="mx-auto mt-10 flex max-w-lg items-center justify-center gap-3 sm:gap-5" role="list" data-id="element-175" data-mp="ojby32dvgee">
          {steps.map((step, index) => <li key={step} className="flex items-center gap-3 sm:gap-5" data-id="element-176" data-mp="3n32t27iqt9ok" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="font-display text-[1.6rem] text-brand-gold" data-id="element-177" data-mp="3i3zpysmbpdj8">
                  →
                </span>}
              <span className="rounded-full border border-brand-gold/40 bg-white px-5 py-2.5 font-body text-[13px] font-bold uppercase tracking-[0.16em] text-brand-charcoal sm:text-[14px]" data-id="element-178" data-mp="em7z5hjxazmm">
                {step}
              </span>
            </li>)}
        </ol>

        <img src={MOCKUP_URL} alt="The complete Barber Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[560px] object-contain lg:max-w-[780px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(20, 40, 59, 0.18))'
      }} data-id="element-179" data-mp="4q4nnl36lon0" />
      </div>
    </section>;
}